import React, {useContext, useRef, useState} from "react";
import {TableContainer, Tooltip} from "@mui/material";
import TableScroll from "../../../../../components/global/table/TableScroll";
import TablePaginationComponent from "../../../../../components/global/table/TablePagination";
import {PageContext} from "../../../../../context/pages";
import {useLazyQuery} from "@apollo/client";
import {DNS_REMOTES_DOCUMENT} from "../../../../../actions/get";
import {useDebouncedEffect} from "../../../../../hooks/useDebouncedEffect";
import {useParams} from "react-router";
import TableIPAddressGroups from "../IPAddressGroups/TableIPAddressGroups";

const IPAddressGroups = () => {
    const table = useRef(null);
    const { filter, setFilter } = useContext(PageContext);
    const [sortActive, setSortActive] = useState('sortL7ResourceId');

    const { id: partnerClientAccountId } = useParams();

    const [getFilter, { data, loading }] = useLazyQuery(DNS_REMOTES_DOCUMENT);
    const getVariables = () => {
        const proxy = {
            limit: filter.limit,
            page: filter.page + 1,
            // deletedAtEq: null,
            partnerClientAccountId: Number(partnerClientAccountId),
            [sortActive]: filter?.sort?.[sortActive]?.toUpperCase() || 'DESC',
        };

        if (filter?.id) {
            proxy.id = Number(filter?.id);
        }

        if (filter?.name) {
            proxy.name = String(filter?.name)
        }

         !filter?.sort?.checked ? proxy.deletedAtEq = null : proxy.deletedAtNeq = null

        return proxy;
    };

    function customTrim(address, length) {
        const getStringValue = (value) => {
            if (value === null || value === undefined) {
                return '-';
            }

            if (Array.isArray(value)) {
                return value.join(', ');
            }

            if (typeof value === 'object') {
                return JSON.stringify(value);
            }

            return String(value);
        };

        const fullText = getStringValue(address);
        const isTruncated = fullText.length > length;
        const displayText = isTruncated ? fullText.substring(0, length) + '...' : fullText;

        const content = (
            <span style={{ whiteSpace: 'nowrap' }}>
                {displayText}
            </span>
        );

        return isTruncated ? <Tooltip title={fullText}>{content}</Tooltip> : content;
    }

    useDebouncedEffect(
        () => {
            getFilter({ variables: getVariables() });
        },
        500,
        [filter],
    );
    return (
        <>
            <div>
                <TableScroll tableRef={table}>
                    <TableContainer>
                        <TableIPAddressGroups
                            data={data}
                            setFilter={setFilter}
                            filter={filter}
                            sortActive={sortActive}
                            setSortActive={setSortActive}
                            partnerClientAccountId={partnerClientAccountId}
                            customTrim={customTrim}
                        />
                        <TablePaginationComponent
                            filter={filter}
                            setFilter={setFilter}
                            count={data && data?.dnsRemotes?.info?.totalCount}
                            getFilter={getFilter}
                            getVariables={getVariables()}
                            type={'FILTER_ACTIVE'}
                        />
                    </TableContainer>
                </TableScroll>
            </div>
        </>
    )
};
export default IPAddressGroups;
